import { render, staticRenderFns } from "./UsefulReserveTable.vue?vue&type=template&id=4b973279&scoped=true&"
import script from "./UsefulReserveTable.vue?vue&type=script&lang=js&"
export * from "./UsefulReserveTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b973279",
  null
  
)

export default component.exports